import {
  AGR_FREE_DATA,
  AGR_SET_REQUESTS_LOADING_STATE,
  AGR_SET_CURRENT_REQUEST,
  AGR_GET_DOC_STATUS_LIST,
  AGR_SET_REQUEST_FILTER,
  AGR_CLEAR_REQUEST_LIST,
  AGR_GET_REQUEST_LIST, // Получение списка запросов на КП, согласно установленному текущему фильтру
  AGR_CREATE_REQUEST,
  AGR_CANCEL_REQUEST,
  AGR_POST_REQUEST,
  AGR_ADD_FILE,
  AGR_DEL_FILE,
  AGR_CONFIRM_FILE,
  AGR_CHANGE_COMMENT,
  AGR_DELETE_COMMENT,
  AGR_ADD_DETAILS,
  AGR_DEL_DETAILS,
  AGR_ADD_ROW,
  AGR_DEL_ROW,
  AGR_UPD_ROW,
  AGR_UPD_ROW_PLACE,
  AGR_UPD_HEADER,
  AGR_GET_INVOICES,
  AGR_GET_DEPT_USERS

} from '../actions/agreements'
import axios from 'axios'
import { UI_REQUEST, UI_SUCCESS, UI_ERROR } from '../actions/ui'
const state = {
  currentAgreement: {},
  agreementsList: [],
  agreementsCount: 0,
  agrStatesList: [],
  currentAgreementFilter: null,
  agrListLoading: false,
  deptusers: []
}

const getters = {
  getCurrentAgreementState: state => state.currentAgreement.DS_ID,
  getCurrentAgreementID: state => state.currentAgreement.DOC_ID,
  getCurrentAgreement: state => state.currentAgreement,
  getCurrentAgreementsCount: state => Number(state.agreementsCount),
  getCurrentAgreementComments: state => state.currentAgreement.COMMENTS_TAB,
  getCurrentAgreementAvailKP: state => state.currentAgreement.AVAIL_KP,
  getCurrentAgreementOwnKP: state => state.currentAgreement.INCLUDED_KP,
  getCurrentAgreementDetails: state => state.currentAgreement.DETAILS,
  getAgreementManagers: state => state.deptusers,
  getCurrentAgreementFiles: state => {
    return state.currentAgreement.FILE_LIST || []
  },
  getCurrentAgreementAvailStates: state => {
    return state.currentAgreement.AVAIL_STATUS || []
  },
  getCurrentAgreementAvailReports: state => state.currentAgreement.AVAIL_REPORTS,
  getCurrentAgreementRoute: state => state.currentAgreement.ROUTE,
  getCurrentAgreementsList: state => state.agreementsList,
  getAgrStatesList: state => state.agrStatesList,
  getAgrListLoading: state => state.agrListLoading,
  getCurrentAgreementFilter: state => {
    var cf = state.currentAgreementFilter
    return cf
  }

}

const actions = {
  [AGR_FREE_DATA]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      commit(AGR_FREE_DATA)
      resolve('success')
    }),

  [AGR_GET_DOC_STATUS_LIST]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      commit(AGR_SET_REQUESTS_LOADING_STATE, true)
      dispatch(UI_REQUEST, { action: 'AGR_GET_DOC_STATUS_LIST', topic: 'Запрос списка статусов договоров', error: null })
      axios({ url: '/api/org/agreements/getAgrStatusList.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(AGR_GET_DOC_STATUS_LIST, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'AGR_GET_DOC_STATUS_LIST' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_GET_DOC_STATUS_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_GET_DOC_STATUS_LIST', result: err })
          reject(new Error(err))
        })
        .finally(() => {
          commit(AGR_SET_REQUESTS_LOADING_STATE, false)
        })
    }),
  [AGR_GET_DEPT_USERS]: ({ commit, dispatch }) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_GET_DEPT_USERS', topic: 'Запрос списка менеджеров', error: null })
      axios({ url: '/api/org/admin/getDeptUsers.php', method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(AGR_GET_DEPT_USERS, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'AGR_GET_DEPT_USERS' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_GET_DEPT_USERS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_GET_DEPT_USERS', result: err })
          reject(new Error(err))
        })
        .finally(() => {
        })
    }),

  [AGR_GET_INVOICES]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      commit(AGR_SET_REQUESTS_LOADING_STATE, true)
      dispatch(UI_REQUEST, { action: 'AGR_GET_INVOICES', topic: 'Запрос списка счетов', error: null })
      axios({ url: '/api/org/agreements/getAgrInvoicesList.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            commit(AGR_GET_INVOICES, resp.data.data)
            dispatch(UI_SUCCESS, { action: 'AGR_GET_INVOICES' })
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_GET_INVOICES', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_GET_INVOICES', result: err })
          reject(new Error(err))
        })
        .finally(() => {
          commit(AGR_SET_REQUESTS_LOADING_STATE, false)
        })
    }),

  [AGR_GET_REQUEST_LIST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('Called action AGR_GET_REQUEST_LIST, params  ', params)
      dispatch(UI_REQUEST, { action: 'AGR_GET_REQUEST_LIST', topic: 'Запрос списка договоров', error: null })
      // commit(AGR_CLEAR_REQUEST_LIST)
      var reqData = {
        DS_ID: state.currentAgreementFilter || 1,
        PAGE: params.PAGE || 1,
        PPC: params.PPC || 10,
        SEARCH: params.SEARCH
      }
      if (params.SEARCH) {
        commit(AGR_CLEAR_REQUEST_LIST)
        reqData.PAGE = 1
      }
      commit(AGR_SET_REQUESTS_LOADING_STATE, true)
      axios({ url: '/api/org/agreements/getAgreementsListNew.php', data: reqData, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_GET_REQUEST_LIST' })
            commit(AGR_GET_REQUEST_LIST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_GET_REQUEST_LIST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_GET_REQUEST_LIST', result: err })
          reject(new Error(err))
        })
        .finally(() => {
          commit(AGR_SET_REQUESTS_LOADING_STATE, false)
        })
    }),

  [AGR_SET_REQUEST_FILTER]: ({ commit, dispatch }, filterItem) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_SET_REQUEST_FILTER', topic: 'Установка списка договоров', error: null })
      console.log('Called action AGR_SET_REQUEST_FILTER ', filterItem)
      if (filterItem.filter !== state.currentAgreementFilter) {
        commit(AGR_SET_REQUEST_FILTER, filterItem.filter)
        commit(AGR_CLEAR_REQUEST_LIST)
        dispatch(AGR_GET_REQUEST_LIST, { PAGE: filterItem.PAGE, PPC: filterItem.PPC, SEARCH: filterItem.SEARCH })
          .then(resp => {
            dispatch(UI_SUCCESS, { action: 'AGR_SET_REQUEST_FILTER' })
            resolve()
          })
          .catch((err) => {
            dispatch(UI_ERROR, { action: 'AGR_SET_REQUEST_FILTER', result: err })
            reject(err)
          })
      } else {
        dispatch(UI_SUCCESS, { action: 'AGR_SET_REQUEST_FILTER' })
        resolve()
      }
    }),

  [AGR_SET_CURRENT_REQUEST]: ({ commit, dispatch }, requestItem) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_SET_CURRENT_REQUEST', topic: 'Установка текущего договора', error: null })
      console.log('Called action AGR_SET_CURRENT_REQUEST ', requestItem)
      commit(AGR_SET_CURRENT_REQUEST, requestItem)
      dispatch(UI_SUCCESS, { action: 'AGR_SET_CURRENT_REQUEST' })
      resolve()
    }),

  [AGR_CREATE_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_CREATE_REQUEST', topic: 'Создание договора', error: null })
      axios({ url: '/api/org/agreements/createNewAgreement.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_CREATE_REQUEST' })
            commit(AGR_CREATE_REQUEST, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_CREATE_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_CREATE_REQUEST', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_CANCEL_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      console.log('AGR_CANCEL_REQUEST action called')
      dispatch(UI_REQUEST, { action: 'AGR_CANCEL_REQUEST', topic: 'Удаление договора', error: null })
      dispatch(AGR_POST_REQUEST, params)
        .then(resp => {
          console.log('AGR_POST_REQUEST returned responce to AGR_CANCEL_REQUEST', resp)
          if (resp.error === 'ok') {
            console.log('AGR_CANCEL_REQUEST result is OK, commiting AGR_CANCEL_REQUEST mutation')
            dispatch(UI_SUCCESS, { action: 'AGR_CANCEL_REQUEST' })
            commit(AGR_CANCEL_REQUEST, resp)
            resolve()
          } else {
            dispatch(UI_ERROR, { action: 'AGR_CANCEL_REQUEST', result: resp.data.error_text })
            reject(new Error(resp.error_text))
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_CANCEL_REQUEST', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_POST_REQUEST]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_POST_REQUEST', topic: 'Изменение состояния договора', error: null })
      axios({ url: '/api/org/agreements/postAgreement.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_POST_REQUEST' })
            commit(AGR_POST_REQUEST, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_POST_REQUEST', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_POST_REQUEST', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_ADD_DETAILS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_ADD_DETAILS', topic: 'Добавление детальной части договора', error: null })
      axios({ url: '/api/org/agreements/addAgreementKP.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_ADD_DETAILS' })
            commit(AGR_ADD_DETAILS, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_ADD_DETAILS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_ADD_DETAILS', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_ADD_ROW]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_ADD_ROW', topic: 'Добавление детальной части договора', error: null })
      axios({ url: '/api/org/agreements/addAgreementRow.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_ADD_ROW' })
            commit(AGR_ADD_ROW, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_ADD_ROW', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_ADD_ROW', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_DEL_ROW]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_DEL_ROW', topic: 'Добавление детальной части договора', error: null })
      axios({ url: '/api/org/agreements/delAgreementRow.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_DEL_ROW' })
            commit(AGR_DEL_ROW, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_DEL_ROW', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_DEL_ROW', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_UPD_ROW]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_UPD_ROW', topic: 'Добавление детальной части договора', error: null })
      axios({ url: '/api/org/agreements/updAgreementRow.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_UPD_ROW' })
            commit(AGR_UPD_ROW, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_UPD_ROW', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_UPD_ROW', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_UPD_HEADER]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_UPD_HEADER', topic: 'Добавление детальной части договора', error: null })
      axios({ url: '/api/org/agreements/editAgrHeader.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_UPD_HEADER' })
            commit(AGR_UPD_HEADER, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_UPD_HEADER', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_UPD_HEADER', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_UPD_ROW_PLACE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_UPD_ROW_PLACE', topic: 'Добавление детальной части договора', error: null })
      axios({ url: '/api/org/agreements/updAgreementRowPlace.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_UPD_ROW_PLACE' })
            commit(AGR_UPD_ROW, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_UPD_ROW_PLACE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_UPD_ROW_PLACE', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_DEL_DETAILS]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_DEL_DETAILS', topic: 'Удаление детальной части договора', error: null })
      axios({ url: '/api/org/agreements/delAgreementKP.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_DEL_DETAILS' })
            commit(AGR_DEL_DETAILS, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_DEL_DETAILS', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_DEL_DETAILS', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_ADD_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_ADD_FILE', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/agreements/uploadAgreementDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_ADD_FILE' })
            commit(AGR_ADD_FILE, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_ADD_FILE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_ADD_FILE', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_CONFIRM_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_CONFIRM_FILE', topic: 'Добавление файла', error: null })
      axios({ url: '/api/org/agreements/confirmAgreementDocument.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_CONFIRM_FILE' })
            commit(AGR_CONFIRM_FILE, resp.data.data)
            resolve(resp.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_CONFIRM_FILE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_CONFIRM_FILE', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_DEL_FILE]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_DEL_FILE', topic: 'Удаление файла', error: null })
      axios({ url: '/api/org/agreements/delAgreementFile.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_DEL_FILE' })
            commit(AGR_DEL_FILE, resp.data.data)
            resolve(resp.data.error)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_DEL_FILE', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_DEL_FILE', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_CHANGE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_CHANGE_COMMENT', topic: 'Изменение комментария', error: null })
      axios({ url: '/api/org/agreements/updAgreementComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_CHANGE_COMMENT' })
            commit(AGR_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_CHANGE_COMMENT', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_CHANGE_COMMENT', result: err })
          reject(new Error(err))
        })
    }),

  [AGR_DELETE_COMMENT]: ({ commit, dispatch }, params) =>
    new Promise((resolve, reject) => {
      dispatch(UI_REQUEST, { action: 'AGR_DELETE_COMMENT', topic: 'Удаление комментария', error: null })
      axios({ url: '/api/org/agreements/delAgreementComment.php', data: params, method: 'POST' })
        .then(resp => {
          if (resp.data.error === 'ok') {
            dispatch(UI_SUCCESS, { action: 'AGR_DELETE_COMMENT' })
            commit(AGR_CHANGE_COMMENT, resp.data.data)
            resolve(resp.data.data)
          } else {
            dispatch(UI_ERROR, { action: 'AGR_DELETE_COMMENT', result: resp.data.error_text })
            reject(resp.data.error_text)
          }
        })
        .catch((err) => {
          dispatch(UI_ERROR, { action: 'AGR_DELETE_COMMENT', result: err })
          reject(new Error(err))
        })
    })
}

const mutations = {
  [AGR_FREE_DATA]: state => {
    state.currentAgreement = {}
    state.agreementsList = []
    state.agrStatesList = []
    state.deptusers = []
    state.currentAgreementFilter = null
    state.agrListLoading = false
  },
  [AGR_GET_DOC_STATUS_LIST]: (state, resp) => {
    console.log('AGR_GET_DOC_STATUS_LIST mutation initiated, ', resp)
    state.agrStatesList = resp
  },
  [AGR_GET_DEPT_USERS]: (state, resp) => {
    console.log('AGR_GET_DEPT_USERS mutation initiated, ', resp)
    state.deptusers = resp
  },
  [AGR_GET_INVOICES]: (state, resp) => {
    console.log('AGR_GET_INVOICES mutation initiated, ', resp)
    state.currentAgreement.INVOICES = resp
  },
  [AGR_CLEAR_REQUEST_LIST]: (state) => {
    console.log('AGR_CLEAR_REQUEST_LIST mutation initiated, ')
    state.agreementsList.splice(0, state.agreementsList.length)
  },
  [AGR_GET_REQUEST_LIST]: (state, resp) => {
    console.log('AGR_GET_REQUEST_LIST mutation initiated, ', resp)
    state.agreementsList = resp.rows
    state.agreementsCount = resp.total
  },
  [AGR_SET_REQUEST_FILTER]: (state, resp) => {
    console.log('AGR_SET_REQUEST_FILTER mutation initiated, ', resp)
    state.currentAgreementFilter = resp
  },
  [AGR_SET_REQUESTS_LOADING_STATE]: (state, resp) => {
    console.log('AGR_SET_REQUESTS_LOADING_STATE mutation initiated, ', resp)
    state.agrListLoading = resp
  },
  [AGR_SET_CURRENT_REQUEST]: (state, resp) => {
    console.log('AGR_SET_CURRENT_REQUEST mutation initiated, ', resp)
    state.currentAgreement = resp
  },
  [AGR_CREATE_REQUEST]: (state, orderItem) => {
    console.log('AGR_CREATE_REQUEST mutation initiated', orderItem)
    // Проверяем, является ли текущий фильтр запросов соответствующим состоянию нового запроса
    // eslint-disable-next-line eqeqeq
    if (state.currentAgreementFilter == orderItem.DS_ID) {
      // Если да, то добавляем новый запрос в гобальный список запросов
      state.agreementsList.push(orderItem)
    }
  },
  [AGR_CANCEL_REQUEST]: (state, resp) => {
    console.log('AGR_CANCEL_REQUEST mutation called. RESP is ', resp)
    var reqIndex = state.agreementsList.findIndex(req => req.TEMP_NUM === resp.TEMP_NUM)
    if (reqIndex !== -1) {
      state.agreementsList.splice(reqIndex, 1)
    }
  },
  [AGR_POST_REQUEST]: (state, resp) => {
    console.log('AGR_POST_REQUEST mutation called. RESP is ', resp)
    var reqIdx = state.agreementsList.findIndex(req => req.TEMP_NUM === resp.TEMP_NUM)
    if (reqIdx !== -1) {
      state.agreementsList.splice(reqIdx, 1)
    }
    /*
    var reqItem = state.agreementsList.find(req => req.TEMP_NUM === resp.TEMP_NUM)
    if (typeof reqItem !== 'undefined') {
      reqItem.DS_ID = resp.SIGNAL_ID
      reqItem.AVAIL_STATUS = resp.AVAIL_STATUS
    }
    */
  },
  [AGR_ADD_DETAILS]: (state, responce) => {
    console.log('AGR_ADD_DETAILS mutation called, payload ', responce)
    state.currentAgreement.DETAILS = responce.DETAILS
    state.currentAgreement.AVAIL_KP = responce.AVAIL_KP
    state.currentAgreement.INCLUDED_KP = responce.INCLUDED_KP
  },

  [AGR_ADD_ROW]: (state, responce) => {
    console.log('AGR_ADD_ROW mutation called, payload ', responce)
    state.currentAgreement.DETAILS.push(responce)
  },

  [AGR_DEL_ROW]: (state, responce) => {
    console.log('AGR_DEL_ROW mutation called, payload ', responce)
    var reqIndex = state.currentAgreement.DETAILS.findIndex(req => req.CONTR_DID === responce)
    if (reqIndex !== -1) {
      state.currentAgreement.DETAILS.splice(reqIndex, 1)
    }
  },

  [AGR_UPD_ROW]: (state, responce) => {
    console.log('AGR_UPD_ROW mutation called, payload ', responce)
    var reqIndex = state.currentAgreement.DETAILS.findIndex(req => req.CONTR_DID === responce.CONTR_DID)
    if (reqIndex !== -1) {
      state.currentAgreement.DETAILS.splice(reqIndex, 1, responce)
    }
  },

  [AGR_UPD_HEADER]: (state, responce) => {
    console.log('AGR_UPD_HEADER mutation called, payload ', responce)
    state.currentAgreement.DOC_NUM = responce.DOC_NUM
    state.currentAgreement.DOC_DATE = responce.DOC_DATE
  },

  [AGR_DEL_DETAILS]: (state, responce) => {
    console.log('AGR_DEL_DETAILS mutation called, payload ', responce)
    state.currentAgreement.DETAILS = responce.DETAILS
    state.currentAgreement.AVAIL_KP = responce.AVAIL_KP
    state.currentAgreement.INCLUDED_KP = responce.INCLUDED_KP
  },
  [AGR_ADD_FILE]: (state, responce) => {
    console.log('AGR_ADD_FILE mutation called, payload ', responce)
    state.currentAgreement.FILE_LIST.splice(0, state.currentAgreement.FILE_LIST.length)
    state.currentAgreement.FILE_LIST.push.apply(state.currentAgreement.FILE_LIST, responce)
  },
  [AGR_CONFIRM_FILE]: (state, responce) => {
    console.log('AGR_CONFIRM_FILE mutation called, payload ', responce)
    state.currentAgreement.FILE_LIST.splice(0, state.currentAgreement.FILE_LIST.length)
    state.currentAgreement.FILE_LIST.push.apply(state.currentAgreement.FILE_LIST, responce)
  },
  [AGR_DEL_FILE]: (state, responce) => {
    console.log('AGR_DEL_FILE mutation called, payload ', responce)
    state.currentAgreement.FILE_LIST.splice(0, state.currentAgreement.FILE_LIST.length)
    state.currentAgreement.FILE_LIST.push.apply(state.currentAgreement.FILE_LIST, responce)
  },
  [AGR_CHANGE_COMMENT]: (state, responce) => {
    console.log('AGR_CHANGE_COMMENT mutation called, payload ', responce)
    state.currentAgreement.COMMENTS_TAB = responce
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
